export default __webpack_public_path__ + "static/media/Ella Han - Co-Chair.9f14c7af.jpg";